import Splide from '@splidejs/splide';

(function () {
  'use strict';

  const selectors = {
    splide: '.js-gallery-reviews',
    testimonialParent: '.js-testimonial',
    prevButton: '.testimonial__arrow__prev',
    nextButton: '.testimonial__arrow__next',
  };

  const init = () => {

    const testimonialInstances = document.querySelectorAll(selectors.testimonialParent);

    testimonialInstances.forEach((instance) => {
      const splideElement = instance.querySelector(selectors.splide);
      const prevButton = instance.querySelector(selectors.prevButton);
      const nextButton = instance.querySelector(selectors.nextButton);

      if (splideElement instanceof HTMLElement) {
        const mainSplide = new Splide(splideElement, {
          type: 'loop',
          perPage: 3,
          perMove: 1,
          gap: '30px',
          breakpoints: {
            1024: {
              perPage: 2,
            },
            480: {
              perPage: 1,
            }
          },
          pagination: false,
          arrows: false
        }).mount();

        if (prevButton instanceof HTMLElement) {
          prevButton.addEventListener('click', () => mainSplide.go('<'));
        }

        if (nextButton instanceof HTMLElement) {
          nextButton.addEventListener('click', () => mainSplide.go('>'));
        }
      }

    })
  };

  window.addEventListener('load', init);
})();
